"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _messages = require("./messages");
// Expecting clickHandler (function), currentPage (number), and finalPage (number) from props, isPrevButton (bool)
const PrevNextPageButton = props => {
  const isDisabled = props.isPrevButton ? props.currentPage === 1 : props.currentPage === props.finalPage;
  const msgs = _messages.messages[props.language];
  return /*#__PURE__*/_react.default.createElement("button", {
    "aria-label": props.isPrevButton ? "".concat(msgs.prev, " (").concat(isDisabled ? msgs.disabled : props.currentPage - 1, ")") : "".concat(msgs.next, " (").concat(isDisabled ? msgs.disabled : props.currentPage + 1, ")"),
    className: "PaginationButton " + (props.isPrevButton ? "Pagination-prevPageButton" : "Pagination-nextPageButton"),
    disabled: isDisabled,
    onClick: props.clickHandler
  }, props.isPrevButton ? /*#__PURE__*/_react.default.createElement(_Icon.default, {
    icon: "chevron_left",
    className: "Pagination-buttonIconLeft",
    size: "md"
  }) : null, props.children, !props.isPrevButton ? /*#__PURE__*/_react.default.createElement(_Icon.default, {
    icon: "chevron_right",
    className: "Pagination-buttonIconRight",
    size: "md"
  }) : null);
};
var _default = exports.default = PrevNextPageButton;